import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import {
	PartConfiguratorFormApi,
	PartConfiguratorFormApi_GetConfiguratorTreeModelResponse,
} from "src/api/generated/erp/configurator/api/partConfiguratorFormApi.ts";
import dayjs from "dayjs";
import { logError } from "src/errorHandling/errorLogging.ts";
import { ConfiguratorTreeModelSource } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeModelSource.ts";
import { ConfiguratorTreeItemModel } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeItemModel.ts";
import { AavoEnvironment } from "src/api/generated/io/aavo/shared/aavoEnvironment";

export async function getStoredConfiguratorTreeModelOrCreateNew({
	configuratorType,
	source,
}: {
	configuratorType: PartConfiguratorType;
	source?: ConfiguratorTreeModelSource;
}): Promise<PartConfiguratorFormApi_GetConfiguratorTreeModelResponse> {
	return await PartConfiguratorFormApi.getConfiguratorTreeModel({
		rootConfiguratorType: configuratorType,
		source: source,
	});
}

export async function storeConfiguratorTreeModelToServer({
	storageKey,
	rootItem,
	hasUnsavedChanges = false,
}: {
	storageKey: string | undefined | null;
	rootItem: ConfiguratorTreeItemModel;
	hasUnsavedChanges?: boolean;
}) {
	if (storageKey == null) return;

	await PartConfiguratorFormApi.saveConfiguratorTreeModel({
		treeModel: {
			savedAt: dayjs().toISOString(),
			root: rootItem,
			hasUnsavedChanges: hasUnsavedChanges,
		},
	});
}

export async function clearStoredConfiguratorTreeModel({
	configuratorType,
	environmentType,
}: {
	configuratorType: PartConfiguratorType;
	environmentType: AavoEnvironment;
}) {
	try {
		const storageKey = await PartConfiguratorFormApi.clearSavedConfiguratorTreeModel({ configuratorType });
		const fullLocalStorageKey = getFullLocalStorageKey(storageKey, environmentType);
		if (fullLocalStorageKey != null) {
			localStorage.removeItem(fullLocalStorageKey);
		}
	} catch (e) {
		logError(e);
	}
}

function getFullLocalStorageKey(storageKey: string | undefined | null, environmentType: AavoEnvironment) {
	if (storageKey == null) return undefined;
	const environmentPrefix = environmentType === "PROD" ? "" : `${environmentType}-`;
	return `${environmentPrefix}configuratorTreeModelV2#${storageKey}`;
}
